import { defineElement, replaceContainerWithPreservation } from '~/utils';

class SiblingProductSwitcher extends HTMLElement {
  constructor() {
    super();
    this.variants = this.querySelectorAll('input[name="sibling-product"]');
    this.sectionId = this.getAttribute('data-section-id');

    this.productCache = new Map();
  }

  connectedCallback() {
    this.attachEventListeners();
    // this.preloadSiblingProducts();
  }

  attachEventListeners() {
    this.variants.forEach((variant) => {
      variant.addEventListener('change', this.handleVariantChange.bind(this));
    });
  }

  async handleVariantChange(event) {
    try {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      const selectedVariantHandle = event.target.value;
      const selectedVariantId = event.target.dataset.productId;

      let productSection = this.productCache.get(selectedVariantHandle);
      if (!productSection) {
        productSection = await this.fetchProductSection(selectedVariantHandle);
        this.productCache.set(selectedVariantHandle, productSection);
      }

      const mainProductSection = document.querySelector('[data-main-product-container]');

      replaceContainerWithPreservation(mainProductSection, productSection.cloneNode(true));
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (this.hasAttribute('url-update-false')) {
        return;
      }

      const updatedSelectedVariant = document.querySelector(`input[name="sibling-product"][value="${selectedVariantHandle}"]`);
      if (updatedSelectedVariant) {

        updatedSelectedVariant.focus();
      }

      this.updateWindowHistory(selectedVariantHandle, selectedVariantId);
      this.updateEGiftCardPreview(selectedVariantHandle);

      document.dispatchEvent(new CustomEvent('product:switched', { detail: { productId: selectedVariantId } }));
    } catch (error) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      console.error(error);
    }
  }

  async fetchProductSection(productHandle) {
    let fetchUrl = `/products/${productHandle}?section_id=${this.sectionId}`;

    // Preserve edit_cart param so the fetched section initializes in edit mode
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.get('edit_cart') === 'true') {
      fetchUrl += '&edit_cart=true';
    }

    const response = await fetch(fetchUrl);
    const responseText = await response.text();
    const parser = new DOMParser();
    const responseDocument = parser.parseFromString(responseText, 'text/html');
    return responseDocument.querySelector('[data-main-product-container]');
  }

  preloadSiblingProducts() {
    this.variants.forEach((variant) => {
      const handle = variant.value;
      if (!this.productCache.has(handle)) {
        this.fetchProductSection(handle)
          .then((section) => {
            this.productCache.set(handle, section);
          })
          .catch((error) => {
            console.error(`Failed to preload product: ${handle}`, error);
          });
      }
    });
  }

  updateWindowHistory(selectedVariantHandle, selectedVariantId) {
    let newUrl = `/products/${selectedVariantHandle}`;

    // Preserve edit_cart param across sibling switches
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.get('edit_cart') === 'true') {
      newUrl += '?edit_cart=true';
    }

    window.history.pushState({ path: newUrl }, '', newUrl);
    window.dispatchEvent(new CustomEvent('url:changed', { detail: { productId: selectedVariantId } }));
  }

  updateEGiftCardPreview(selectedVariantHandle) {
    // Check if e-gift card preview section exists
    const previewContainer = document.getElementById('Egift-Preview');
    if (!previewContainer) return;

    const sectionId = previewContainer.getAttribute('data-section-id');

    // Fetch the e-gift card preview section
    fetch(`/products/${selectedVariantHandle}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const responseDocument = parser.parseFromString(responseText, 'text/html');
        const newPreviewSection = responseDocument.getElementById('Egift-Preview');

        if (newPreviewSection) {
          previewContainer.replaceWith(newPreviewSection);
        }
      })
      .catch((error) => {
        console.error('Error updating e-gift card preview:', error);
      });
  }
}

defineElement('sibling-product-switcher', SiblingProductSwitcher);
